import React from "react";
import { GraphQLProvider } from "../providers/GraphQLProvider";
import { UserProvider } from "../providers/UserProvider";
import { CoveoProvider } from "../providers/CoveoProvider";
import { PublicConfigProvider } from "../providers/PublicConfigProvider";
import { ReactQueryProvider } from "../providers/ReactQueryProvider";
import { MainNavigation } from "../components/nav/MainNavigation";
import { LegacyMainNavigation } from "../components/nav/legacy/LegacyMainNavigation";

type MainNavigationWrapperProps = {
  readonly config: {
    readonly RAILS_ROOT_URL: string;
    readonly COVEO_ORGANIZATION_ID: string;
    readonly GRAPHQL_PUBLIC_API_URL: string;
    readonly GRAPHQL_PRIVATE_API_URL: string;
    readonly LOCALIZED_IN?: string[];
  };
  readonly locale: string;
  readonly useNewNav?: boolean;
};

export default function MainNavigationWrapper({
  config,
  locale,
  useNewNav = false,
}: MainNavigationWrapperProps) {
  return (
    <ReactQueryProvider>
      <PublicConfigProvider config={config}>
        <GraphQLProvider>
          <UserProvider>
            <CoveoProvider>
              {useNewNav ? <MainNavigation /> : <LegacyMainNavigation />}
            </CoveoProvider>
          </UserProvider>
        </GraphQLProvider>
      </PublicConfigProvider>
    </ReactQueryProvider>
  );
}
